import * as React from "react";
export const League = (props) => {
    return props.details.showLeagueInEventCard
        ? React.createElement("div", { className: `rj-ev-list__${props.componentPrefix}__section-item rj-ev-list__${props.componentPrefix}__league`, "data-uat": `div-ev-list-${props.componentPrefix}-league` },
            React.createElement("span", { className: "rj-ev-list__name-text", "data-uat": "span-ev-list-name-text" }, props.details.event.leagueName))
        : React.createElement(React.Fragment, null);
};
//# sourceMappingURL=League.js.map